import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'main-features',
  templateUrl: './main-features.component.html',
  styleUrls: ['./main-features.component.scss']
})
export class MainFeaturesComponent {}
